import React from 'react';
import { RefreshCw } from 'lucide-react';
import { CourseData } from '../../types/CourseData';

interface CourseTabNavigationProps {
  selectedCourseData: CourseData | undefined;
  setActiveTab: (courseId: number, tab: 'CONNECT' | 'PREVIEW') => void;
  selectedCourse: number;
  showDocumentCache: boolean;
  handleRefresh: () => void;
  isRefreshing: boolean;
}

const CourseTabNavigation: React.FC<CourseTabNavigationProps> = ({
  selectedCourseData,
  setActiveTab,
  selectedCourse,
  showDocumentCache,
  handleRefresh,
  isRefreshing
}) => {
  return (
    <div className="flex-shrink-0">
      <div className="border-b border-gray-200">
        <div className="flex px-6 justify-between items-center">
          <div className="flex">
            <button
              className={`px-4 py-2 border-b-2 font-medium ${
                selectedCourseData?.activeTab === 'CONNECT'
                  ? 'border-black text-black'
                  : 'border-transparent text-gray-500'
              }`}
              onClick={() => selectedCourse && setActiveTab(selectedCourse, 'CONNECT')}
            >
              CONNECT
            </button>
            <button
              className={`px-4 py-2 border-b-2 font-medium ${
                selectedCourseData?.activeTab === 'PREVIEW'
                  ? 'border-black text-black'
                  : 'border-transparent text-gray-500'
              }`}
              onClick={() => 
                selectedCourse && 
                selectedCourseData?.connectionState === 'connected' && 
                setActiveTab(selectedCourse, 'PREVIEW')
              }
            >
              PREVIEW
            </button>
          </div>
          {showDocumentCache && selectedCourseData?.connectionState === 'connected' && (
            <button
              onClick={handleRefresh}
              disabled={isRefreshing}
              className="flex items-center mr-2.5 mt-1 mb-1.5 gap-2 px-4 py-2 bg-black border border-gray-500 rounded-lg text-white font-semibold hover:bg-gray-800 hover:text-gray-200"
              title="Refresh"
            >
              Refresh Preview
              <RefreshCw size={18} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseTabNavigation;